/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PagedResponse } from '../../../shared/contract/paged-response.contract';
import { getHttpParameters } from '../../../shared/utils/get-http-parameters';
import { AutomatedTransferConfiguration } from '../contract/automated-transfer-configuration.contract';
import {
  AutomatedTransferCustomerNotificationConfigResponse,
  NotificationSettings,
} from '../contract/customer-notifications.contract';
import { SearchCustomer } from '../contract/search-customer.contract';
import { SearchCustomersRequest } from '../contract/search-customers-request.contract';

@Injectable({
  providedIn: 'root',
})
export class CustomersApiService {
  private http = inject(HttpClient);
  private url: string = environment.APP_ORGANISATION_SERVICE_BASE_URL + '/api/v1/customers';

  searchCustomers(request: SearchCustomersRequest): Observable<PagedResponse<SearchCustomer>> {
    const params = getHttpParameters(request, true);
    return this.http.get<PagedResponse<SearchCustomer>>(`${this.url}/search/all`, { params });
  }

  getAutomatedTransferConfig(customerId: string): Observable<AutomatedTransferConfiguration> {
    return this.http.get<AutomatedTransferConfiguration>(`${this.url}/${customerId}/automated-transfer-configuration`);
  }

  updateAutomatedTransferConfig(automatedTransferConfiguration: AutomatedTransferConfiguration): Observable<string> {
    return this.http.post<string>(
      `${this.url}/update-automated-transfers-configuration`,
      automatedTransferConfiguration,
      {
        responseType: 'text' as 'json',
      },
    );
  }

  getAutomatedTransfersCustomerNotificationConfig(
    customerId: string,
  ): Observable<AutomatedTransferCustomerNotificationConfigResponse> {
    return this.http.get<AutomatedTransferCustomerNotificationConfigResponse>(
      `${this.url}/${customerId}/configuration/notifications/automated-transfer`,
    );
  }

  updateAutomatedTransferCustomerNotificationConfig(
    customerId: string,
    customerNotificationConfig: Record<string, NotificationSettings>,
  ): Observable<string> {
    return this.http.post<string>(
      `${this.url}/${customerId}/configuration/notifications/automated-transfer`,
      customerNotificationConfig,
      {
        responseType: 'text' as 'json',
      },
    );
  }
}
